// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3-Tew","file":"styles_file__MOIX_"};